import { useState } from 'react';
import CustomSearchInput from 'components/CustomComponents/CustomSearchInput';

export default function EMSSearch({ API, openEMS }) {
  const [findItemData, setFindItemData] = useState([]);
  const [ready, setReady] = useState(true);

  function searchItems(query) {
    setReady(false);

    API.search(query).then((data) => {
      setFindItemData(
        data.map(({ id, name }) => (
          <div className="custom-search__result-item" key={id} onClick={() => openEMS(id)}>
            {name}
            <span style={{ float: 'right', marginLeft: 30 }}>{`id: ${id}`}</span>
          </div>
        )),
      );

      setReady(true);
    });
  }

  return (
    <CustomSearchInput
      clearFunc={() => setFindItemData([])}
      loading={!ready}
      minContainerWidth={400}
      placeholder="Search"
      results={findItemData}
      searchFunc={searchItems}
    />
  );
}
